import { __extends } from 'tslib';
import classNames from 'classnames';
import React__default, { PureComponent } from 'react';
import isEqual from 'react-fast-compare';
import styles from './Highlighter.module.scss.js';

var Highlighter = (function (_super) {
    __extends(Highlighter, _super);
    function Highlighter(props) {
        var _this = _super.call(this, props) || this;
        _this.isInterpolate = function (props, nextProps) {
            var r = false;
            if (nextProps.value &&
                nextProps.value.props &&
                nextProps.value.props.i18nKey &&
                props.value &&
                props.value.props &&
                props.value.props.i18nKey) {
                r = true;
            }
            return r;
        };
        _this.dropHighLight = function () {
            setTimeout(function () {
                _this.setState({
                    isHighlighted: false,
                });
            }, 450);
        };
        _this.state = {
            isHighlighted: false,
        };
        return _this;
    }
    Highlighter.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var isInterpolate = this.isInterpolate(this.props, nextProps);
        if (isInterpolate && !isEqual(this.props.value.props, nextProps.value.props)) {
            this.setState({
                isHighlighted: true,
            }, this.dropHighLight);
        }
        if (this.props.value !== nextProps.value) {
            this.setState({
                isHighlighted: true,
            }, this.dropHighLight);
        }
    };
    Highlighter.prototype.render = function () {
        var _a;
        var value = this.props.value !== undefined && this.props.value !== null ? this.props.value : '';
        return (React__default.createElement("span", { className: classNames(styles.wrapper, this.props.className, (_a = {},
                _a[styles.wrapperHighlight] = this.state.isHighlighted,
                _a)) }, value));
    };
    return Highlighter;
}(PureComponent));

export { Highlighter as default };
//# sourceMappingURL=Highlighter.js.map
